import type { ReactElement } from "react";
import { useMemo } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { createRangeChipItem } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/createRangeChipItem";

import { MAX_CHIPS_GROUP_AMOUNT } from "../../../constants";
import type FindEngagementFilter from "../../../models/EngagementFilter/EngagementFilter";
import type { IEngagementFilterDto } from "../../../types/leadsSearchFilters.dto";
import { formatNumber, formatPercent, formatFloatingNumber, formatTime } from "../../../utils/numberFormatters";

const EngagementFilterResult = ({
    filter: { options },
    value,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindEngagementFilter>): ReactElement | null => {
    const handleClose = (filterKey: keyof IEngagementFilterDto) => {
        const mappedValue = { ...value };
        delete mappedValue[filterKey];

        onFilterUpdate(mappedValue);
        onFilterValueRemove?.(mappedValue);
    };

    const chipItems = useMemo(() => {
        return [
            createRangeChipItem("avgPagesPerVisit", formatNumber, options, value, onGetLifecycleStatus),
            createRangeChipItem("avgVisitDuration", formatTime, options, value, onGetLifecycleStatus),
            // @ts-expect-error FIXME: Type 'string | number' is not assignable to type 'string'
            createRangeChipItem("avgVisitsPerUser", formatFloatingNumber, options, value, onGetLifecycleStatus),
            createRangeChipItem("bounceRate", formatPercent, options, value, onGetLifecycleStatus),
        ].filter((item): item is ChipItem => item !== null);
    }, [options, value, onGetLifecycleStatus]);

    if (!chipItems?.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleClose}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default EngagementFilterResult;
